import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { ApiService } from '../../../services/api.service';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ActivatedRoute, Router } from '@angular/router';
import { SchemeWiseRoutePopupComponent } from '../../../components/scheme-wise-route-popup/scheme-wise-route-popup.component';
import { TableModule } from 'primeng/table';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-cfi',
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule, DialogModule, ReactiveFormsModule, ToastModule, SchemeWiseRoutePopupComponent, TableModule],
  providers: [MessageService],
  templateUrl: './cfi.component.html',
})
export class CFIComponent implements OnInit {
  showSearchPopup = false;
  searchInput: HTMLInputElement | null = null;
  displayDialog = false

  tabs = [
    { key: 'all', label: 'Indigenous CFI' },
    { key: 'priority', label: 'Foreign CFI' },
  ];
  activeTab = this.tabs[0].key;
  columns: any[] = [
    // Primary Identifiers
    { field: 'indent_no', header: 'Indent No.' },
    { field: 'user_created', header: 'Created By' },
    { field: 'created_on', header: 'Created On' },
    { field: 'file_status', header: 'Status' },
    { field: 'remark', header: 'Remark' },
  ];
  searchTerm = '';
  statusFilter: 'all' = 'all';
  startDate = '';
  endDate = '';
  cfiRows: any[] = [];
  createForm = new FormGroup({
    indent_no: new FormControl(''),
    remark: new FormControl(''),

  });
  constructor(private api: ApiService, private messageService: MessageService, private router: Router) { }

  ngOnInit(): void {
    this.getCfiRows();
  }


  setTab(key: string): void {
    this.activeTab = key;
  }

  resetFilters(): void {
    this.searchTerm = '';
    this.statusFilter = 'all';
    this.startDate = '';
    this.endDate = '';
  }

  getCfiRows(): void {
    this.api.getAPI('/transaction/cfi/').subscribe((res: any) => {
      this.cfiRows = res.data;
    });
  }


  result: any[] = [];
  searchLoading = false;
  onSearchChange(value: string) {
    if (!value || value.trim() === '') {
      this.result = [];
      return;
    }
    this.searchLoading = true;
    this.api.getAPI(`/transaction/search/cfi/?search=${encodeURIComponent(value.trim())}`).subscribe((res: any) => {
      this.result = res.data || [];
      this.searchLoading = false;
    });
  }
  selectedCfi: any = null;
  showDialog = false
  selectCfi(row: any): void {
    this.selectedCfi = row;
    this.showSearchPopup = false;
    this.showDialog = true;
     this.router.navigate(['/cfi/transaction'], {
    queryParams: { id: row.id }
  });
  }

  file: any;
  submitForm() {
    if (!this.file) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please upload a file'
      });
      return;
    }
    const fd = new FormData();
    fd.append('indent_no', this.createForm.value.indent_no);
    fd.append('remark', this.createForm.value.remark);
    fd.append('action', 'create');
    fd.append('item_file', this.file);
    this.api.postAPI('/transaction/cfi/', fd).subscribe((res: any) => {
      this.currentCfiRowData = res
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'CFI submitted successfully'
      });
      
    // ✅ FIXED
    if (res?.error_file_url) {
      const fullUrl = environment.APIUrl + res.error_file_url;
      window.open(fullUrl, '_blank');
      console.log("fullUrl",fullUrl);
      
    }
      this.showDialog = false;
      this.displayDialog = true
      this.createForm.reset();
      this.getCfiRows();

    });

  }
  currentCfiRowData: any;
  updateCfi(event: any) {
    this.currentCfiRowData = event;
    this.router.navigate(['cfi/transaction'], { queryParams: { id: event.id } });
  }
  cfiListPopup = false;
  cfiListTableData: any[] = [];
  cfiListColumns: any[] = [
    { field: 'ser', header: 'Ser' },
    { field: 'part_no', header: 'Part No/Pattern No' },
    { field: 'indenter_referance', header: 'Indenter referance no & date' },
    { field: 'project_class', header: 'Project/class of ship' },
    { field: 'main_equipment', header: 'Main equipment' },
    { field: 'equipment_code', header: 'Equipment code' },
    { field: 'equipment_category', header: 'Equipment category' },
    { field: 'item_desc', header: 'Item description' },
    { field: 'qty', header: 'Qty' },
    { field: 'brief_specs', header: 'Brief specs' },
    { field: 'substitute', header: 'Substitute available if any' },
    { field: 'unit_cost', header: 'Unit Cost' },
    { field: 'currency', header: 'Currency' },
    { field: 'total_cost', header: 'Total cost' },
    { field: 'last_source_of_supply', header: 'Last source of supply & year' },
    { field: 'lpp', header: 'LPP' },
    { field: 'frequency_requirement', header: 'Frequency of requirement' },
    { field: 'availability_stock', header: 'Availability of stock sample' },

  ];

  viewCfi(event: any) {
    this.currentCfiRowData = event;
    this.api.getAPI(`/transaction/cfi/item/${event.id}/`).subscribe((res: any) => {
      this.cfiListTableData = res.data;
      this.cfiListPopup = true;
    })
  }
  deleteCfi(event: any) {
    this.currentCfiRowData = event;
    this.api.postAPI('/transaction/cfi/', { id: event.id, action: 'delete' }).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'CFI deleted successfully'
      });
      this.getCfiRows();
    })
  }

  onNeedformSubmit(event: any) {
    this.displayDialog = false;
    const routePayload: any = {
      cfi: this.currentCfiRowData?.id,
      remark: event.internalComment,
      is_external: event.shareType === 'external',
    };
    if (event.shareType === 'external') {
      routePayload.unit_id = event.selectedUnit?.id;
      routePayload.command = event.selectedCommand;
    } else {
      routePayload.user = event.selectedUser?.id;
    }
    this.api.postAPI('/file_mange/cfi/editor/add/', routePayload).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'CFI editor assigned successfully'
      });
      this.displayDialog = false;
      this.getCfiRows();
      this.updateCfi(this.currentCfiRowData)
    })
  }
  onFileChange(event: any) {
    this.file = event.target.files[0];
    console.log(this.file);
  }

  downloadCSV(): void {
    const headers = ['Part No/Pattern No', 'Ser', 'Indenter Reference no & date', 'Project/class of ship', 'Main equipment', 'Equipment code', 'Equipment category (E/L/W/H)', 'Item description', 'Quantity', 'Brief Specs', 'Substitute available if any', 'Unit Cost', 'Currency', 'Total cost', 'Last source of supply & year', 'LPP', 'Frequency of Requirement', 'Availability of stock sample'];
    const csv = headers.join(',') + '\r\n';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'item-cfi.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }





}